import { render } from "./Dashboard3.html?vue&type=template&id=5a35d25e&scoped=true&ts=true"
import script from "./Dashboard3.ts?vue&type=script&lang=ts"
export * from "./Dashboard3.ts?vue&type=script&lang=ts"

import "./Dashboard3.scss?vue&type=style&index=0&id=5a35d25e&lang=scss&scoped=true"

import exportComponent from "/Users/fahadnaeem/Documents/MYLE Codes/myle-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a35d25e"]])

export default __exports__